import script from "./ThuChiThongKeUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ThuChiThongKeUser.vue?vue&type=script&setup=true&lang=js"

import "./ThuChiThongKeUser.vue?vue&type=style&index=0&id=85bb9c62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85bb9c62"]])

export default __exports__